"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminReservationSummary = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const useForm_1 = require("../../../../hooks/useForm");
const Textarea_1 = require("../../../Form/Field/Textarea");
const Info_1 = require("../Info");
require("./index.scss");
const className = 'admin-reservation-summary';
const AdminReservationSummary = (props) => {
    const { formConfig, formOnSubmit = () => { }, formValidator = () => ({}), formOnChange, ...summaryProps } = props;
    const { fields } = (0, useForm_1.useLegacyForm)(formConfig, formOnSubmit, formValidator, formOnChange);
    const reservationSummaryInfo = {
        ...summaryProps,
        commentElement: (react_1.default.createElement(Textarea_1.FormFieldTextarea, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary:Comment', defaultMessage: 'Comment' }), modificators: ['none-resize', ...fields.comment.modifiers], value: fields.comment.value, onChange: fields.comment.onEvent, error: fields.comment.error, disabled: fields.comment.disabled, hidden: fields.comment.hidden })),
        commentElementHidden: fields.comment.hidden,
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Info_1.ReservationSummaryInfo, { ...reservationSummaryInfo })));
};
exports.AdminReservationSummary = AdminReservationSummary;
//# sourceMappingURL=index.js.map